module.exports = __webpack_public_path__ + "static/media/save.055e6272.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/cuyoavalcheque/img/save.png
 ** module id = 1428
 ** module chunks = 0
 **/